import { atom } from 'jotai';

import { SummaryConfig } from '@repo/sdk/models/components';

export const calculateNavigationIds = (
  equipmentId: string | undefined,
  equipmentPool: SummaryConfig[]
): { nextEquipmentId: string | undefined; prevEquipmentId: string | undefined } => {
  if (!equipmentId || !equipmentPool.length) {
    return { nextEquipmentId: undefined, prevEquipmentId: undefined };
  }

  const currentIndex = equipmentPool.findIndex((summary) => summary.referenceId === equipmentId);
  if (currentIndex === -1) {
    return { nextEquipmentId: undefined, prevEquipmentId: undefined };
  }

  const nextIndex = (currentIndex + 1) % equipmentPool.length;
  const prevIndex = (currentIndex - 1 + equipmentPool.length) % equipmentPool.length;

  return {
    nextEquipmentId: equipmentPool[nextIndex]?.referenceId,
    prevEquipmentId: equipmentPool[prevIndex]?.referenceId,
  };
};

export const equipmentPoolAtom = atom<SummaryConfig[]>([]);
equipmentPoolAtom.debugLabel = 'SelectedEquipmentState.equipmentPoolAtom';
